<template>
  <div>
    <div class="pb-64" :style="'height:' + (store.state.windowHeight - 180) / 2 + 'px'" style="min-height:300px">
      <el-form ref="form">
        <el-space wrap>
          <el-form-item label="板块:">
            <el-select v-model="obj.selectedBlockValue" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.selectBlockList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目:">
            <el-select v-model="obj.selectedTypeValue" @change="handleSelectChange" style="width:180px">
              <el-option v-for="item in obj.selectTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="期间:">
            <el-select v-model="obj.selectedDayValue" @change="handleSelectChange" style="width:110px">
              <el-option v-for="item in obj.selectDayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排名:">
            <el-select v-model="obj.selectedHeadTailValue" @change="handleSelectChange" style="width:80px">
              <el-option v-for="item in obj.selectedHeadTailList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.selectedCountValue" @change="handleSelectChange" style="width:80px">
              <el-option v-for="item in obj.selectedCountList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="位">
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleRefresh">
              <el-icon class="el-input__icon">
                <refresh />
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </el-form>
      <el-tag type="warning" size="small" v-if="obj.date !== ''">数据截至到 {{ obj.date }}</el-tag>
      <div id="chart" style="width: 100%; height: 100%" ref="chartDomRef"></div>
    </div>
    <div :style="'height:' + (store.state.windowHeight - 180) / 2 + 'px'" style="min-height:300px">
      <el-table :data="obj.dataList" height="100%" :cell-style="cellStyle" @row-click="handleRowClick">
        <el-table-column fixed prop="no" label="排名" sortable />
        <el-table-column fixed prop="name" label="名称" sortable />
        <el-table-column prop="symbol" label="代码" sortable />
        <el-table-column v-if="obj.selectedTypeValue === 'opiCapital' || obj.selectedTypeValue === 'opiCapitalChg' || obj.selectedTypeValue === 'turnover' || obj.selectedTypeValue === 'turnoverChg'"
          prop="value" label="数值(亿)" sortable />
        <el-table-column
          v-else-if="obj.selectedTypeValue === 'chgPct' || obj.selectedTypeValue === 'chg2Pct' || obj.selectedTypeValue === 'chg3Pct' || obj.selectedTypeValue === 'amplitude' || obj.selectedTypeValue === 'volChgPct' || obj.selectedTypeValue === 'turnoverChgPct' || obj.selectedTypeValue === 'opiChgPct' || obj.selectedTypeValue === 'opiCapitalChgPct'"
          prop="value" label="数值(%)" sortable />
        <el-table-column
          v-else-if="obj.selectedTypeValue === 'vol' || obj.selectedTypeValue === 'volChg' || obj.selectedTypeValue === 'opi' || obj.selectedTypeValue === 'opiChg'"
          prop="value" label="数值(万手)" sortable />
        <el-table-column v-else prop="value" label="数值" sortable />
      </el-table>
    </div>
  </div>
</template>
<script>
import { onMounted, onUnmounted, reactive, ref, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { setCharts } from '../module/bar'
import { http } from '../util/http'
import { findObjByField } from '../util/base'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent // vueEvent.emit('event', arg) 
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      selectBlockList: [
        {
          value: 'all',
          label: '全部'
        },
        {
          value: 'gjs',
          label: '贵金属'
        },
        {
          value: 'ysjs',
          label: '有色金属'
        },
        {
          value: 'hs',
          label: '黑色'
        },
        {
          value: 'hg',
          label: '化工'
        },
        {
          value: 'ny',
          label: '能源'
        },
        {
          value: 'yzyl',
          label: '油脂油料'
        },
        {
          value: 'ncp',
          label: '农产品'
        }
      ],
      selectedBlockValue: 'all',
      selectTypeList: [
        {
          value: 'chgPct',
          label: '涨跌幅(结算价)(%)'
        },
        {
          value: 'chg2Pct',
          label: '涨跌幅(收盘价)(%)'
        },
        {
          value: 'chg3Pct',
          label: '实体涨跌幅(%)'
        },
        {
          value: 'amplitude',
          label: '振幅(%)'
        },
        {
          value: 'amplitudePoint',
          label: '振幅点数'
        },
        {
          value: 'trend',
          label: '趋势度'
        },
        {
          value: 'volOpi',
          label: '投机度(均值)'
        },
        {
          value: 'vol',
          label: '成交量'
        },
        {
          value: 'volChg',
          label: '成交量增量'
        },
        {
          value: 'volChgPct',
          label: '成交量增幅(%)'
        },
        {
          value: 'turnover',
          label: '成交额'
        },
        {
          value: 'turnoverChg',
          label: '成交额增量'
        },
        {
          value: 'turnoverChgPct',
          label: '成交额增幅(%)'
        },
        {
          value: 'opi',
          label: '持仓量(均值)'
        },
        {
          value: 'opiChg',
          label: '持仓量增量'
        },
        {
          value: 'opiChgPct',
          label: '持仓量增幅(%)'
        },
        {
          value: 'opiCapital',
          label: '沉淀资金(均值)'
        },
        {
          value: 'opiCapitalChg',
          label: '资金流入增量'
        },
        {
          value: 'opiCapitalChgPct',
          label: '资金流入增幅(%)'
        }
      ],
      selectedTypeValue: 'chgPct',
      selectDayList: [
        {
          value: '1',
          label: '最近1日'
        },
        {
          value: '3',
          label: '最近3日'
        },
        {
          value: '5',
          label: '最近5日'
        },
        {
          value: '10',
          label: '最近10日'
        },
        {
          value: '20',
          label: '最近20日'
        },
        {
          value: '30',
          label: '最近30日'
        },
        {
          value: '40',
          label: '最近40日'
        },
        {
          value: '50',
          label: '最近50日'
        },
        {
          value: '60',
          label: '最近60日'
        }
      ],
      selectedDayValue: '1',
      selectedHeadTailList: [
        {
          value: '1',
          label: '前'
        },
        {
          value: '-1',
          label: '后'
        },
        {
          value: '0',
          label: '前后'
        }
      ],
      selectedHeadTailValue: '1',
      selectedCountList: [
        {
          value: '3',
          label: '3'
        },
        {
          value: '5',
          label: '5'
        },
        {
          value: '10',
          label: '10'
        },
        {
          value: '20',
          label: '20'
        },
        {
          value: '50',
          label: '50'
        },
        {
          value: '100',
          label: '100'
        },
        {
          value: '0',
          label: '全部'
        }
      ],
      selectedCountValue: '0',
      dataList: [],
      date: ''
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.rankData === '') {
        // 无缓存，从后台请求数据
        requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
        // 渲染图表
        var myChart = renderChart()
        // 保存缓存(否则chart无法自适应窗口)
        setStore(myChart)
      }
    }

    // 后台获取数据
    const requestData = () => {
      let formData = new FormData()
      formData.append("block", obj.selectedBlockValue)
      formData.append("category", obj.selectedTypeValue)
      formData.append("interval", obj.selectedDayValue)
      formData.append("sort", obj.selectedHeadTailValue)
      formData.append("limit", obj.selectedCountValue)
      http({
        url: `/rank`,
        method: 'post',
        data: formData
      }).then((res) => {
        processData(res)
        var myChart = renderChart()
        setStore(myChart)
      })
    }

    // 处理数据
    const processData = (res) => {
      // console.log(res)
      obj.dataList = res.data.data
      let no = 1
      obj.dataList.forEach((item) => {
        obj.date = item.date
        item.value = Number(item.value.toString().replace('%', '').replace('亿', '').replace('万手', '')) // 转换成无%和金额单位的数值，便于图标显示和表格排序 toString()为了防止replace遇到数值类型报错 
        item.no = no
        no++
      })
    }

    // 绘制图表
    const renderChart = () => {
      // 设置坐标数据
      let Xdata = obj.dataList.map((item) => item.name)
      let Ydata = obj.dataList.map((item) => item.value)
      // console.log(Xdata)
      // console.log(Ydata)

      // 设置图表标题
      let title = ''
      let tempObj = findObjByField(obj.selectBlockList, 'value', obj.selectedBlockValue)
      title = tempObj.label
      tempObj = findObjByField(obj.selectTypeList, 'value', obj.selectedTypeValue)
      title = title + ' ' + tempObj.label
      tempObj = findObjByField(obj.selectDayList, 'value', obj.selectedDayValue)
      title = title + ' ' + tempObj.label
      let tempObj2 = findObjByField(obj.selectedCountList, 'value', obj.selectedCountValue)
      if (tempObj2.label != "全部"){
        tempObj = findObjByField(obj.selectedHeadTailList, 'value', obj.selectedHeadTailValue)
        title = title + ' ' + tempObj.label
        title = title + '' + tempObj2.label + '位'
      }

      // 生成图表实例
      var myChart = setCharts(chartDomRef.value, '主力合约 ' + title, Xdata, Ydata, '45', '20%', '3%')
      return myChart
    }

    // 保存Store
    const setStore = (myChart) => {
      store.commit('setMyChart', myChart)
      var storeObj = {
        'selectedBlockValue': obj.selectedBlockValue,
        'selectedTypeValue': obj.selectedTypeValue,
        'selectedDayValue': obj.selectedDayValue,
        'selectedHeadTailValue': obj.selectedHeadTailValue,
        'selectedCountValue': obj.selectedCountValue,
        'dataList': obj.dataList,
        'date': obj.date
      }
      store.commit('setRankData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.selectedBlockValue = store.state.rankData.selectedBlockValue
      obj.selectedTypeValue = store.state.rankData.selectedTypeValue
      obj.selectedDayValue = store.state.rankData.selectedDayValue
      obj.selectedHeadTailValue = store.state.rankData.selectedHeadTailValue
      obj.selectedCountValue = store.state.rankData.selectedCountValue
      obj.dataList = store.state.rankData.dataList
      obj.date = store.state.rankData.date
    }

    // 重置画面
    const resetView = () => {
      obj.selectedBlockValue = 'all'
      obj.selectedTypeValue = 'chg2Pct'
      obj.selectedDayValue = '1'
      obj.selectedHeadTailValue = '1'
      obj.selectedCountValue = '0'
      obj.dataList = []
      obj.date = ''
      requestData()
    }

    /**
     * 事件处理区域
     */

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      requestData()
    }

    // 按钮刷新事件
    const handleRefresh = (e) => {
      requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row) => {
      if (row.row.value > 0 && row.columnIndex === 3) {
        return { color: 'red' }
      } else if (row.row.value < 0 && row.columnIndex === 3) {
        return { color: 'green' }
      } else {
        return { color: 'black' }
      }
    }

    return {
      obj,
      chartDomRef,
      store,
      handleSelectChange,
      handleRefresh,
      handleRowClick,
      cellStyle
    }
  }
}
</script>
<style lang="scss" scoped></style>
